import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { APP_ROUTES } from 'src/app/app.routes';
import { TranslatePipe } from '@ngx-translate/core';
import { UserApiService } from 'src/app/core/api/user.api';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'emp-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, TranslatePipe, MatFormFieldModule, MatInputModule]
})
export class ResetPasswordComponent {
  private router = inject(Router);
  private commonApi = inject(UserApiService);

  public emailControl = new FormControl<string>(null, { validators: [Validators.required, Validators.email] });

  public onSubmit(): void {
    if (this.emailControl.invalid) {
      this.emailControl.markAsTouched();
    } else {
      this.resetPassword();
    }
  }

  private resetPassword(): void {
    this.commonApi.resetPassword(this.emailControl.value).subscribe({
      next: () => {
        void this.router.navigate([APP_ROUTES.emailSent]);
      },
      error: console.error
    });
  }
}
